import { Typography } from '@lno/components/Typography'
import clsx from 'clsx'
import { styles } from '../styles'
import { CampaignDescription } from './DesenrolaNorthEastDescription'

export const jsxScope = `jsx-${styles.__hash}`

export const DesenrolaNorthEastTitle = () => (
  <Typography
    size="headingM"
    color="high"
    className={clsx(jsxScope, 'desenrola-north-east-section__title')}
    tag="h2"
  >
    Existe uma ação Desenrola com a Serasa no Nordeste?
  </Typography>
)

export const DesenrolaNorthEastDescription = () => {
  return (
    <div
      className={clsx(jsxScope, 'desenrola-north-east-section__description')}
    >
      <CampaignDescription />
    </div>
  )
}
